module.exports = __webpack_public_path__ + "static/media/LED_Detector.9c59f3a7.gif";